module.exports = __webpack_public_path__ + "img/win.e4ee34ae.png";